import Loadable from '../../../../components/loadable';
import prerenderedLoadable from '../../../../components/prerender';

const Page = Loadable(() =>
  import(
    /* webpackChunkName: "business-services-douyin" */ './index'
  )
);

export default prerenderedLoadable(Page);
